import React from "react";
import PageShell from "@/components/PageShell";
import { ShieldCheck, Lock, RotateCcw } from "lucide-react";

const PRIVACY_ITEMS = [
  "نحن نولي خصوصية بياناتك أهمية قصوى. يتم استخدام المعلومات الشخصية فقط لإتمام عمليات الحجز والشراء.",
  "نلتزم بعدم مشاركة أو بيع أي بيانات خاصة بالعملاء لأي طرف ثالث.",
];

const REFUND_ITEMS = [
  {
    title: "المنتجات الرقمية",
    body:
      "نظراً لطبيعة المنتجات الرقمية، فإن الكتب الإلكترونية لا ترد ولا تستبدل بعد إتمام عملية الشراء.",
  },
  {
    title: "الجلسات",
    body:
      "يحق للعميل تأجيل موعد الجلسة بشرط التواصل مع «خدمة العملاء» مسبقاً. وفي حال عدم الحضور للجلسة أو الإلغاء لأسباب تعود للعميل، فإنه لا يحق المطالبة باسترجاع المبلغ.",
  },
];

const PrivacyRefund = () => (
  <PageShell>
    <section
      className="max-w-3xl mx-auto px-6 lg:px-12 py-16"
      data-testid="privacy-refund-page"
    >
      <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full bg-[#F6F4EE] border border-[#E5E1D8] text-[#0A4D3C] text-sm">
        <ShieldCheck className="w-4 h-4" /> سياسة الخصوصية والاسترجاع
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#222222] mt-6">
        سياسة الخصوصية والاسترجاع
      </h1>
      <p className="text-[#5E5C58] mt-4 leading-loose">
        قبل إتمام أي عملية شراء أو حجز على منصة أوتادك، يُرجى الاطلاع على بنود الخصوصية
        والاسترجاع التالية بعناية.
      </p>

      {/* Privacy */}
      <div
        className="mt-10 rounded-2xl border border-[#E5E1D8] bg-[#FAF9F6] p-6"
        data-testid="privacy-section"
      >
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-[#F6F4EE] grid place-items-center text-[#0A4D3C]">
            <Lock className="w-5 h-5" />
          </span>
          <h2 className="font-heading text-2xl text-[#222222]">سياسة الخصوصية</h2>
        </div>
        <ul className="mt-5 list-disc ps-6 space-y-3 text-[#222222] leading-loose">
          {PRIVACY_ITEMS.map((t, i) => (
            <li
              key={i}
              data-testid={`privacy-item-${i + 1}`}
              className="text-base"
            >
              {t}
            </li>
          ))}
        </ul>
      </div>

      {/* Refund */}
      <div
        className="mt-8 rounded-2xl border border-[#E5E1D8] bg-[#FAF9F6] p-6"
        data-testid="refund-section"
      >
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-[#F6F4EE] grid place-items-center text-[#0A4D3C]">
            <RotateCcw className="w-5 h-5" />
          </span>
          <h2 className="font-heading text-2xl text-[#222222]">
            سياسة الاسترجاع وإلغاء المواعيد
          </h2>
        </div>
        <ul className="mt-5 list-disc ps-6 space-y-4 text-[#222222] leading-loose">
          {REFUND_ITEMS.map((it, i) => (
            <li
              key={i}
              data-testid={`refund-item-${i + 1}`}
              className="text-base"
            >
              <span className="font-semibold text-[#0A4D3C]">{it.title}: </span>
              {it.body}
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-10 text-sm text-[#5E5C58] leading-relaxed">
        لأي استفسار يخص الخصوصية أو الاسترجاع، يمكنك التواصل مع{" "}
        <span className="font-semibold text-[#222222]">خدمة العملاء</span> عبر الواتساب على{" "}
        <a
          href="https://wa.me/966538278484"
          target="_blank"
          rel="noopener noreferrer"
          dir="ltr"
          className="text-[#1ebe5b] hover:text-[#159b48]"
          data-testid="privacy-refund-whatsapp-link"
        >
          +966 53 827 8484
        </a>
        .
      </p>
    </section>
  </PageShell>
);

export default PrivacyRefund;
